import styles from "./style.module.sass"
import { numberWithSpaces, toRubbles } from "../libs";
import {PriceInCurrency} from "../../services/menu/models";
import { useTranslation } from "react-i18next";

interface IProps {
    item: PriceInCurrency,
    priceText?: string,
    crossed?: boolean
}

export const PriceComponent = ({item, priceText, crossed}: IProps ) => {
    const {t} = useTranslation(['general']);

    return <span className={styles.priceContainer} style={{ paddingBottom: crossed ? 0 : undefined }} >

        <span className={crossed ? styles.crossedPrice : styles.price}>
            {priceText || numberWithSpaces(toRubbles(item.price))}
        </span>
        <span className={crossed ? styles.crossedCurrency : styles.currency}>
            {t('general:currency.rub')}
        </span>
        { crossed && <span className={styles.crossedOverlay}/> }
    </span>
};

export default PriceComponent;
